export const useSettingStore = defineStore('setting', () => {
  const userHomeSetting = ref<Ccd.UserHomeSetting>({
    tags: [],
    ossHost: '',
    banner: '',
    bannerUrl: '',
  })

  const boost = async () => {
    userHomeSetting.value = await $fetch<Ccd.UserHomeSetting>('/api/kv/userHomeSetting')
  }

  const syncUserHomeSetting = async () => {
    await $fetch('/api/kv/userHomeSetting', { method: 'post', body: userHomeSetting.value })
  }

  return { userHomeSetting, boost, syncUserHomeSetting }
})
